import BaseTable from 'components/Tables/BaseTable';
import { actions as scenariosDescriptorsActions } from 'ducks/scenariosDescriptors';
import { actions as scenariosDescriptorsConditionsActions } from 'ducks/scenariosDescriptorsConditions';
import { sortBy } from 'lodash';
import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { getImmutableStoreData, lookUpIdValueSelector } from 'selectors/generic';
import arrayToObject from 'utils/arrayToObject';
import columns from 'utils/tables/columns/scenarioExposure/scenarioConditionsExposure';
import { TABLE_HEIGHT_SPLIT_4VIEW } from 'utils/ui/constants';
import { currentUser } from 'selectors/currentUser';

const TABLE_HEIGHT = TABLE_HEIGHT_SPLIT_4VIEW(64);

const Component = props => {
  const { conditionsFilter, descriptorId, descriptorFilter, scenario } = props;
  const {
    conditions, conditionsById, descriptorsById, scenarioDescriptorConditions,
    scenarioDescriptorsData, units, user
  } = props;
  const { createCondition, createScenarioDescriptor, removeCondition, updateCondition } = props;
  const tableRef = React.useRef(null);

  const filteredScenarioDescriptors = scenarioDescriptorsData.filter(sd =>
    sd.scenario_id === scenario.id &&
    descriptorsById[sd.descriptor_id].descriptor_type_id === descriptorFilter
  );

  // Only used for ERC and PROC
  const scenarioDescriptor = filteredScenarioDescriptors.find(fsd =>
    (descriptorId && fsd.descriptor_id === descriptorId)
  );

  const filteredConditions = conditions.filter(v => v.type === conditionsFilter);

  const filteredSDC = scenarioDescriptorConditions.filter(sdc =>
    sdc.scenario_descriptor_id === (scenarioDescriptor && scenarioDescriptor.id)
  );

  const [selectedIds, setSelectedIds] = useState(filteredSDC.map(fsdc => fsdc.condition_id));
  const [loading, setLoading] = useState(false);

  useEffect(
    () => setSelectedIds(filteredSDC.map(fsdc => fsdc.condition_id)),
    [scenarioDescriptorConditions, descriptorId]
  );

  // TODO Adding Checked info to table, there should be a better way
  const fsdcByConditionId = arrayToObject(filteredSDC, 'condition_id');

  let rows = [];
  if (descriptorId) {
    rows = filteredConditions.map(element => {
      const baseElement = { ...element, value: '' };
      // TODO fsdcByConditionId[element.id] condition has this because the state suffers
      // TODO update on useEffect and not with action, should be corrected
      if (selectedIds.includes(element.id) && fsdcByConditionId[element.id]) {
        const valor = fsdcByConditionId[element.id].value;
        const unit_id = fsdcByConditionId[element.id].unit_id;
        const ok_flag = fsdcByConditionId[element.id].ok_flag;
        const notes = fsdcByConditionId[element.id].notes;
        return {
          ...baseElement,
          tableData: { checked: true },
          value: valor ? valor : '',
          unit_id: unit_id ? unit_id : '',
          ok_flag: ok_flag ? ok_flag : false,
          notes: notes ? notes : ''
        };
      } else {
        return { ...baseElement, tableData: { checked: false } };
      }
    });
  }

  const reOrderedRows = sortBy(rows, [row => !selectedIds.includes(row.id), 'id']);

  return (
    <React.Fragment>
      <BaseTable
        ref={tableRef}
        title={'ESCOLHA AS CONDIÇÕES'}
        columns={columns(user, units)}
        data={reOrderedRows}
        order={false}
        onRowClick={() => null}
        paging={false}
        options={{
          // toolbar: false,
          // search: false,
          maxBodyHeight: TABLE_HEIGHT,
          minBodyHeight: TABLE_HEIGHT,
          selection: true,
          showTextRowsSelected: false,
          showSelectAllCheckbox: false,
          selectionProps: rowData => ({
            //checked: prevInterSubstanceIds.includes(rowData.id)
            //onClick: (event , rowData) => this.handleCheckboxClick(event,rowData),
          })
        }}
        isLoading={loading}
        editable={{
          onRowUpdate: (newData, oldData) => {
            if (oldData.tableData.checked) {
              const id_sdc = filteredSDC.find(fsdc => fsdc.condition_id === newData.id).id;
              return updateCondition(
                id_sdc,
                {
                  ...newData,
                  unit_id: newData.unit_id === '' ? null : newData.unit_id
                }
              );
            } else {
              return createCondition({
                scenario_descriptor_id: scenarioDescriptor.id,
                condition_id: newData.id,
                ...newData
              });
            }
          }
        }}
        onSelectionChange={(rows, difRow) => {
          setLoading(true);
          const scenarioDescriptorExists = scenarioDescriptorsData
            .filter(sd =>
              sd.scenario_id === scenario.id &&
              descriptorsById[sd.descriptor_id].descriptor_type_id === descriptorFilter &&
              sd.descriptor_id === descriptorId
            )
            .length > 0;
          if (!scenarioDescriptorExists) {
            createScenarioDescriptor({ descriptor_id: descriptorId, scenario_id: scenario.id })
              .then(response => {
                createCondition({
                  scenario_descriptor_id: response.id,
                  condition_id: difRow.id,
                  unit_id: conditionsById[difRow.id].unit_id
                });
              })
              .finally(() => setLoading(false));
          } else {
            if (rows.length > selectedIds.length) {
              createCondition({
                scenario_descriptor_id: scenarioDescriptor.id,
                condition_id: difRow.id,
                unit_id: conditionsById[difRow.id].unit_id
              })
                .finally(() => setLoading(false));
            } else {
              const id_sdc = filteredSDC.find(fsdc => fsdc.condition_id === difRow.id).id;
              removeCondition(id_sdc)
                .finally(() => setLoading(false));
            }
          }
        }}
      />
    </React.Fragment>
  );
};

const makemapStateToProps = () => {
  const conditions = getImmutableStoreData('conditions');
  const units = lookUpIdValueSelector('units', ['name']);
  const mapStateToProps = (state, props) => ({
    conditions: conditions(state),
    conditionsById: state.conditions.models,
    descriptorsById: state.descriptors.models,
    scenarioDescriptorsData: state.scenarioDescriptors.data,
    scenarioDescriptorConditions: state.scenarioDescriptorConditions.data,
    units: units(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  createScenarioDescriptor: data => dispatch(scenariosDescriptorsActions.createPromise(data)),
  createCondition: data => dispatch(scenariosDescriptorsConditionsActions.createPromise(data)),
  updateCondition: (id, data) => dispatch(scenariosDescriptorsConditionsActions.updatePromise(id, data)),
  removeCondition: id => dispatch(scenariosDescriptorsConditionsActions.removePromise(id))
});

export default connect(makemapStateToProps, mapDispatchToProps)(Component);
